import { useState } from "react";

export default function DropdownCards() {
  const faqs = [
    {
      question: "What is Kerrigan?",
      answer:
        "Kerrigan is an AI reasoning platform that learns intuition in expert decision-making environments, beginning with institutional finance."
    },
    {
      question: "I have data sources already, how do I connect?",
      answer:
        "We are aiming to connect to major institutional workflows including Bloomberg, CapIQ, Refinitiv, Excel, S3, SQL, and proprietary systems. Feel free to reach out with specific requests."
    },
    {
      question: "How do I install it?",
      answer:
        "Join the waitlist. We’ll send you our beta-invite."
    },
    {
      question: "Latency, Data Privacy, and Security",
      answer:
        "Our product is intended to run in a hybrid, on-compute and cloud compute environment. If you require on-prem processing, we can accommodate that based on your compute needs. We will not be accessing or training with your data unless specifically authorized."
    },
    {
      question: "Can I customize the features",
      answer:
        "Yes. You’ll be able to create custom reasoning nodes, integrations, and evaluation workflows. We are actively building a C++ and Python SDK."
    },
    {
      question: "Can my team use it together?",
      answer:
        "Yes. As long as the external data licenses you obtain allow for shared use."
    },
    {
      question: "What does it cost?",
      answer:
        "Final pricing depends on usage, seats, and integrations."
    }
  ];

  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div
      className="faq-list"
      style={{
        zIndex: 5
      }}
    >
      {faqs.map((item, index) => {
        const isOpen = openIndex === index;

        return (
          <div
            className="faq-card"
            key={index}
          >
            <button
              className="faq-question"
              onClick={() =>
                setOpenIndex(isOpen ? null : index)
              }
            >
              {item.question}
              <span
                style={{
                  transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.2s ease"
                }}
              >
                ▼
              </span>
            </button>

            {isOpen && (
              <div
                className="faq-answer"
              >
                {item.answer}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
